import { render, staticRenderFns } from "./sortBy.template?vue&type=template&id=2e13bf5a&lang=pug&"
import script from "./sortBy.client?vue&type=script&lang=ts&"
export * from "./sortBy.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e13bf5a')) {
      api.createRecord('2e13bf5a', component.options)
    } else {
      api.reload('2e13bf5a', component.options)
    }
    module.hot.accept("./sortBy.template?vue&type=template&id=2e13bf5a&lang=pug&", function () {
      api.rerender('2e13bf5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/sortBy/sortBy.component.vue"
export default component.exports